const getCardChargesByType = (supportedCards, cardType) => {
  if (Array.isArray(supportedCards)) {
    return supportedCards.filter(card => card.cardType === cardType).map(({ amount }) => amount);
  }

  return [];
};

export default getCardChargesByType;
